/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit One/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function One({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentPaymentPlans/Configuration/CustomPlanRulesets/AddRuleset/TxPlanGroupChooser/Content/One"
  
}) {
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtTypographyFontsizeXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.xs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let rulesetTxPlanGroups0NameValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'tx_plan_groups.[0].name',
})
  return (<React.Fragment
>
<div
  data-testid="One.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Label
  viewPath={`${viewPath}/Label`}
 text="treatment plan group"
 color={dtColorsNeutral700}
 fontSize={dtTypographyFontsizeXs}
 marginLeft={dtSpaceXs}
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginLeft={dtSpaceXs}
 marginTop={dtSpaceXs}
 data="ruleset.tx_plan_groups.[0].name"
 text={rulesetTxPlanGroups0NameValueData}
/>
</div>
{children}
</React.Fragment>)
}